export default {
	section_banner: {
		title: {
			one: 'How to',
			two: 'use',
		},
		main_title: {
			one: 'merchants',
		},
		paragraph: {
			one: 'Customers can quickly make payments themselves. Please try ',
			two: 'JPWorldPay, which allows you to pay immediately with a mobile phone ',
			three: 'without cash or card.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	section_we_offer_sec: {
		label: { one: 'JPWorldPay Wallet' },
		title: {
			one: 'Using A Payment',
			two: 'Method',
		},
		paragraph: {
			one: 'JPWorldPay is your trusted electronic wallet, designed for fast, secure, and convenient cryptocurrency transactions. Whether you are shopping online or offline, JPWorldPay makes it easy to manage and spend your digital assets anytime, anywhere.',
		},
		white_box_1st: {
			heading: 'Select JPWorldPay',
			paragraph: 'Simply select JPWorldPay on your phone and use it easily.',
		},
		white_box_2nd: {
			heading: 'Offline Store Payment',
			paragraph:
				'Select your wallet and then select the Offline Store Payment.',
		},
		white_box_3rd: {
			heading: 'Scan The QR Code',
			paragraph:
				'If you scan the QR code on the kiosk, the payment is complete.',
		},
		cta_buttons: {
			one: 'Create A Free Account',
		},
		mobile: {
			heading: 'Enjoy Shopping Anywhere',
			subheading: 'With cryptocurrency stored in your JPWorldPay wallet',
		},
	},

	future_currency_sec: {
		label: 'JPWorldPay Wallet',
		heading: {
			one: 'Welcome To The',
			two: 'Future Currency',
			three: 'System',
		},
		future_box_1st: {
			heading: 'Secure Payment',
			paragraph:
				'JPWorldPay does not disclose your information during QR code transactions.',
		},
		future_box_2nd: {
			heading: 'Any Company',
			paragraph:
				'Pay instantly and securely at offline merchants anywhere, 24 hours a day.',
		},
		future_box_3rd: {
			heading: 'Touch Free',
			paragraph:
				'Do not worry about cash or credit card- open the application and pay.',
		},
	},

	seller_access_sec: {
		label: 'Fastest Payment System',
		title: {
			one: 'Sellers Can',
			two: 'Access',
			three: 'Easily',
		},
		paragraph:
			'All you have to do is register the items for sale at the JPWorldPay kiosk. Once registered, payments will be processed directly through the JPWorldPay kiosk, making transactions simple and efficient. This streamlined process saves time and enhances the customer experience. Enjoy seamless sales with minimal setup and maximum convenience.',
		cta_buttons: {
			one: 'Get Started',
		},
	},
	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
